<template>
  <tr>
    <td>
      <router-link :to="`/products/${product.id}`">
        {{ product.name }}
      </router-link>
    </td>
    <td v-text="product.product_category ? product.product_category.name : ''"></td>
    <td v-text="product.unit ? product.unit.name : ''"></td>
    <td>
      <div>
        <input type="text" class="form-control" v-model="product.referenznummer" @input="updateReferenznummer($event.target.value)">
      </div>
    </td>
    <td class="text-right">{{ product.price  | priceFromCentEuro  }}</td>
    <td class="text-right">
      <price-input :price="price"
        @input="bla"
      />
    </td>
    <td class="text-right">
      {{ cheapestSupplier | priceFromCentEuro }}
    </td>
    <td class="text-right">
      {{ product.quantity }}
    </td>
    <td class="text-right">
      {{ product.orders.length ? product.orders[0].ordered_quantity : '' }}
    </td>
    <td class="text-center">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openWarehouses', product)">
        <i class="fas fa-warehouse"></i>
      </a>
    </td>
    <td class="text-center">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openSuppliers', {product, productSuppliersSorted})">
        <i class="fas fa-truck"></i>
      </a>
    </td>
  </tr>
</template>

<script>
import { groupSuppliers, groupNewestSuppliers } from 'src/util/helpers'
import PriceInput from 'src/components/price-input'
import debounce from 'lodash/debounce'

export default {
  props: ['product', 'onlyShowAction'],
  components: { PriceInput },
  data () {
    return {
      price: '',
      debounceUpdatePrice: debounce(function (price) {
        this.updatePrice(price)
      }, 1000)
    }
  },
  methods: {
    bla (price) {
      this.price = price
      this.debounceUpdatePrice(price)
    },
    async updatePrice (price) {
      await this.initCsrf()
      const referenznummer = this.product.referenznummer

      const url = `/products/${this.product.id}/suppliers/${this.product.supplier_id}`
      this.$http.post(url, { price, referenznummer }).then(({ data }) => {
        this.product.suppliers.unshift(data)
        this.$notify({
          message: 'Preis erfolgreich aktualisiert.',
          type: 'success'
        })
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    },

    updateReferenznummer: debounce(async function (referenznummer) {
      await this.initCsrf()

      const url = `/product_supplier/${this.product.product_supplier_id}`
      this.$http.put(url, { referenznummer }).then(({ data }) => {
        this.$notify({
          message: 'Referenznummer erfolgreich aktualisiert.',
          type: 'success'
        })
      }).catch(({ response }) => { console.log(response) })
    }, 1500)
  },
  computed: {
    productSuppliers () {
      return groupSuppliers(this.product.suppliers)
    },
    productSuppliersSorted () {
      return groupNewestSuppliers(this.product.suppliers)
    },
    cheapestSupplier () {
      return this.productSuppliersSorted.length ? this.productSuppliersSorted[0].price : ''
    },
    currentPrice () {
      if (this.productSuppliers.hasOwnProperty(this.product.supplier_id)) {
        return this.productSuppliers[this.product.supplier_id].price
      }
      return ''
    }
  },
  created () {
    if (this.productSuppliers.hasOwnProperty(this.product.supplier_id)) {
      this.price = this.productSuppliers[this.product.supplier_id].price
    }
  }
}
</script>

<style scoped>
  .form-group {
    margin-bottom: 0;
  }
</style>
